<mat-button-toggle-group [(value)]="selectedLanguage">

    <mat-button-toggle [value]="'en'"  (change)="onLanguageChange($event.value)">
        English
    </mat-button-toggle>
    <mat-button-toggle [value]="'ur'"  (change)="onLanguageChange($event.value)">
        Urdu
    </mat-button-toggle>
</mat-button-toggle-group>